import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchPhraseById } from "./phraseService";
import "./PhraseDetailPage.css";

const difficultyColor = (d) => {
 const map = { BEGINNER: "#4caf50", INTERMEDIATE: "#ff9800", ADVANCED: "#e91e63" };
 return map[d?.toUpperCase()] || "#999";
};

const formatLabel = (s) => s?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) || s;

const PhraseDetailPage = () => {
 const { id } = useParams();
 const navigate = useNavigate();
 const [data, setData] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const load = async () => {
 setLoading(true);
 const res = await fetchPhraseById(id);
 if (res.status === 200 && res.data?.status) {
 setData(res.data.data);
 } else {
 }
 setLoading(false);
 };
 load();
 }, [id]);

 if (loading) return (<><Navbar /><div className="pd-page"><p className="pd-loading">Loading...</p></div><Footer /></>);
 if (!data) return (<><Navbar /><div className="pd-page"><p className="pd-loading">Phrase not found.</p><button className="pd-back" onClick={() => navigate("/study/phrases")}>← Back</button></div><Footer /></>);

 return (
 <>
 <Navbar />
 <div className="pd-page">
 <button className="pd-back" onClick={() => navigate("/study/phrases")}>← Back to Phrases</button>

 <div className="pd-hero">
 <div className="pd-hero-top">
 <h1 className="pd-title">{data.title}</h1>
 <span className="pd-difficulty" style={{ background: difficultyColor(data.difficulty) }}>
 {formatLabel(data.difficulty)}
 </span>
 </div>

 {data.fullForm && <p className="pd-fullform">{data.fullForm}</p>}

 <div className="pd-tags">
 <span className="pd-tag pd-tag-type">{formatLabel(data.type)}</span>
 <span className="pd-tag pd-tag-category">{formatLabel(data.category)}</span>
 </div>

 {(data.pronunciation || data.phoneticSpelling) && (
 <div className="pd-pronunciations">
 {data.pronunciation && (
 <div className="pd-pron-item">
 <span className="pd-pron-label">
 IPA
 <Link to="/study/ipa/lessons" style={{ marginLeft: 4, display: "inline-flex", alignItems: "center", justifyContent: "center", width: 14, height: 14, borderRadius: "50%", background: "#019095", color: "#fff", fontSize: 8, fontWeight: 700, textDecoration: "none" }} title="Learn IPA">ℹ</Link>
 </span>
 <span className="pd-pron-value">{data.pronunciation}</span>
 </div>
 )}
 {data.phoneticSpelling && (
 <div className="pd-pron-item">
 <span className="pd-pron-label">How to say</span>
 <span className="pd-pron-value phonetic">{data.phoneticSpelling}</span>
 </div>
 )}
 </div>
 )}
 </div>

 <div className="pd-card">
 <h3 className="pd-card-title">📝 Meaning</h3>
 <p className="pd-card-text">{data.meaning}</p>
 </div>

 {data.usageNote && (
 <div className="pd-card">
 <h3 className="pd-card-title">💡 Usage</h3>
 <p className="pd-card-text">{data.usageNote}</p>
 </div>
 )}

 {data.exampleSentence && (
 <div className="pd-card">
 <h3 className="pd-card-title">🗣️ Example</h3>
 <p className="pd-example">{data.exampleSentence}</p>
 </div>
 )}

 {data.youtubeLink && (
 <div className="pd-card">
 <h3 className="pd-card-title">🎬 Video Lesson</h3>
 <div className="pd-video-wrapper">
 <iframe
 src={data.youtubeLink.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")}
 title={data.title}
 allowFullScreen
 frameBorder="0"
 />
 </div>
 </div>
 )}
 </div>
 <Footer />
 </>
 );
};

export default PhraseDetailPage;
